/**
 * ConnectionBanner — yellow/amber bar shown when WebSocket is disconnected.
 * Hidden when connected. Shows attempt count and retry button.
 */

import { computed } from '@preact/signals';
import { wsConnected, wsReconnectInfo, forceReconnect } from '../core/ws/client';

/** BannerSlot coordination (P1a): mirrors this banner's own visibility rule. */
export const connectionBannerWantsToShow = computed(() => !wsConnected.value);

export function ConnectionBanner() {
  // Hidden when connected
  if (wsConnected.value) return null;

  const info = wsReconnectInfo.value;

  return (
    <div style={styles.banner}>
      <span style={styles.text}>
        {info
          ? `Reconnecting... (attempt ${info.attempt}/${info.max})`
          : 'Disconnected'}
      </span>
      <button style={styles.retry} onClick={forceReconnect}>
        Retry
      </button>
    </div>
  );
}

const styles: Record<string, Record<string, string | number>> = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '8px 12px',
    background: 'var(--warning)',
    color: '#000',
    fontSize: '12px',
    fontWeight: '600',
    flexShrink: '0',
  },
  text: {
    whiteSpace: 'nowrap',
  },
  retry: {
    background: 'rgba(0, 0, 0, 0.2)',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '4px',
    padding: '2px 10px',
    color: 'inherit',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: 'var(--font)',
  },
};
